import { render, staticRenderFns } from "./marketManagement.vue?vue&type=template&id=d780e556"
import script from "./marketManagement.vue?vue&type=script&lang=js"
export * from "./marketManagement.vue?vue&type=script&lang=js"
import style0 from "./marketManagement.vue?vue&type=style&index=0&id=d780e556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports